import { PaginationSetting } from 'constants/paginationSetting';
import { useState } from 'react';
import { useGetApplicationListQuery, useGetNotificationListQuery } from 'views/utils/graphql/graphql';

export const useRequestHistoryListPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [applicationList, _] = useGetApplicationListQuery({
    variables: {
      count: PaginationSetting.pageCount,
      page: currentPage,
    },
    requestPolicy: 'network-only',
  });

  return {
    applicationList,
    currentPage,
    setCurrentPage,
    perPageCount: PaginationSetting.pageCount,
  };
};
